import { Grid, Paper } from "@mui/material";
import muistyled from "@emotion/styled";

import { FadeInTop } from "../../animations/animations";

export const SkillsContainer = muistyled(Grid, {
  name: "SkillsContainer",
})({
  direction: "column",
  height: "1300px",
  backgroundColor: "#101010",
  display: "flex",
  flexWrap: "wrap",
  overflow: "auto",
});

export const SkillsHeaderWrap = muistyled(Grid, {
  name: "SkillsHeaderWrap",
})({
  display: "flex",
});
export const SkillsHeader = muistyled("h1", {
  name: "SkillsHeader",
})({
  color: "#fff",
  fontSize: "2.5rem",
  fontWeight: "bold",
  textAlign: "center",
  fontFamily: "Oswald",
});

export const SkillsCardsContainer = muistyled(Grid, {
  name: "SkillsCardsContainer",
})({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  margin: "10px",
});

export const SkillsPaper = muistyled(Paper, {
  name: "SkillsPaper",
})({
  height: "350px",
  width: "350px",
  borderRadius: "20px",
  backgroundColor: "#191919",
  boxShadow: "2px 2px 2px #000",
  margin: "20px 20px 20px 20px",
  ":hover": {
    animation: `${FadeInTop} 1s both 1`,
  },
});

export const IconWrap = muistyled(Grid, {
  name: "IconWrap",
})({
  justifyContent: "center",
  alignItems: "center",
});

export const SkillsTitle = muistyled("h1", {
  name: "SkillsTitle",
})({
  color: "#fff",
  textAlign: "center",
  fontSize: "2rem",
  fontFamily: "Oswald",
});

export const SkillsDescription = muistyled("p", {
  name: "SkillsDescription",
})({
  color: "#fff",
  textAlign: "center",
  fontSize: "1.5rem",
  fontFamily: "Oswald",
});
